import { LocalAssignmentAugCtrl } from './local-assignment-aug.controller';

export const LocalAssignmentAugComponent = {
  controller: LocalAssignmentAugCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./local-assignment-aug.html'),
};
